module.exports = __webpack_public_path__ + "static/map-56cca98433a473b4338f389850df66d3.png";